import { styled } from '@acko-tech/building-blocks.ui.common';

import { APP_CONTENT_MAX_WIDTH } from 'Constants/common';

export interface ILayoutStyleProps {
    display?: 'flex' | 'block';
    justify?:
        | 'center'
        | 'flex-start'
        | 'flex-end'
        | 'space-between'
        | 'space-around';
    align?: 'center' | 'flex-start' | 'flex-end';
    hasFixedCTA?: boolean;
}
// TODO: container height to be changed dynamically for fixed layout
export const Container = styled.div<ILayoutStyleProps>`
    min-height: 100vh;
    overflow-y: auto;
    background: #f8f7fc;
    ${(props: any) => props.display && `display: ${props.display}`};
    ${(props: any) => props.justify && `justify-content: ${props.justify}`};
    ${(props: any) => props.align && `align-items: ${props.align}`};
    ${(props: any) => props.minHeight && `min-height: ${props.minHeight}`};

    @media (max-width: 700px) {
        ${(props: any) =>
            props.hasFixedCTA &&
            `padding-bottom: 50px`}; //Header height + Fixed CTA height (50 + 70)
        min-height: 100vh;
        background: #f8f7fc;
        ${(props: any) => props.minHeight && `min-height: ${props.minHeight}`};
    }
`;

export const Wrapper = styled.div<{
    hideMobileHeader: boolean;
    showTimeline: boolean;
}>`
    max-width: ${APP_CONTENT_MAX_WIDTH};
    padding: 20px;
    margin: 0 auto;
    background: #fff;
    min-height: calc(100vh - 120px);
    min-height: ${(props: any) =>
        props.showTimeline ? 'max-content' : 'calc(100vh - 120px)'};
    ${(props: any) => props.showTimeline && `padding-bottom: 100px`};

    border-radius: 10px;

    @media (max-width: 700px) {
        max-width: 100%;
        padding: 0 20px;
        margin: 0 auto;
        overflow-x: hidden;
        border-radius: 0px;
        max-width: 100%;
        padding-bottom: ${(props: any) =>
            props.showTimeline ? '100px' : '20px'};
        min-height: ${(props: any) =>
            props.hideMobileHeader
                ? '100vh'
                : props.showTimeline
                  ? 'max-content'
                  : 'calc(100vh - 120px)'};
    }
`;

export const PageHeading = styled.div`
    margin: 0 auto 32px auto;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: #040222;
`;

export const Timeline = styled.div`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0 20px 24px;
    z-index: 100;
`;

// export const DesktopWrapper = styled.div`
//     display: flex;
//     height: 100vh;
// `;

// export const ImageWrapper = styled.div`
//     flex-grow: 1;
//     display: flex;
//     max-height: 100vh;
//     overflow: hidden;
//     //justify-content: center;
//     // align-items: center;
//     //background-color: #f0f0f0;
//     img {
//         width: 100%;
//         height: 100%;
//         object-fit: cover;
//     }
//     & > div {
//         position: absolute;
//         top: 20px;
//         left: 20px;
//     }
// `;
